import styled from "styled-components";
import MattressSrc from "../../assets/images/mattress/Layer 0.png";
import GreenCircleRegularSrc from "../../assets/images/green-circle-regular.png";
import ThreeDotsSrc from "../../assets/images/3-dots.png";
import FourDotsSrc from "../../assets/images/4-dots.png";

export const MattressImg = styled.img.attrs({
  src: MattressSrc,
})`
  height: 474px;
  width: 700px;
  margin-left: 40px;
  position: absolute;
`;

export const GreenCircleRegular = styled.img.attrs({
  src: GreenCircleRegularSrc,
})`
  position: absolute;
  height: 100px;
  width: 100px;
`;

export const ThreeDots = styled.img.attrs({
  src: ThreeDotsSrc,
})`
  position: absolute;
  height: 33px;
  width: 100px;
`;

export const FourDots = styled.img.attrs({
  src: FourDotsSrc,
})`
  position: absolute;
  height: 143px;
  width: 32px;
`;
